import { type SizeFormSchema, sizeNumberFields, sizeUnitField } from "@msuite/utils/schemas";
import { sizeUnits } from "@msuite/utils/units";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "../localization";
import { InputGroup } from "./input-group";
import { NumberInput } from "./number-input";
import { Select } from "./select";

export function SizeInput() {
	/** Context */
	const methods = useFormContext<SizeFormSchema>();
	const sizeUnit = useWatch({ control: methods.control, name: "sizeUnit" });

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="grid grid-cols-[1fr_150px] gap-x-4">
			<InputGroup>
				{sizeNumberFields.map((field) => {
					return (
						<NumberInput
							key={field}
							hideButtons
							isRequired={false}
							label={t(`calculations.${field}`)}
							control={methods.control}
							name={field}
							min={0}
							variant={sizeUnit}
							step={0.01}
							errorVariant="tooltip"
						/>
					);
				})}
			</InputGroup>
			<Select
				errorVariant="tooltip"
				isRequired
				label={t("units.unit")}
				isNullable={false}
				control={methods.control}
				name={sizeUnitField}
				defaultValue="meters"
				options={sizeUnits.map((unit) => ({
					label: t(`units.${unit}`),
					value: unit,
					item: { unit },
				}))}
			/>
		</div>
	);
}
